import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const ManagerPage = loadable(
  () => import(
    /* webpackChunkName: "manager-page-chunk" */
    './ManagerPage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default ManagerPage;
